exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ant-input[data-v-121fd50a] {\r\n    width: 100%;\n}\n.ant-form-item-label label[data-v-121fd50a]{\r\n    margin-left: 5vw;\n}\n.ant-form-explain[data-v-121fd50a], .ant-form-extra[data-v-121fd50a] {\r\n    margin-left: 5vw;\n}\r\n", ""]);

